var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.724C0 5.57317 4.98625 0.586914 11.1371 0.586914C17.288 0.586914 22.2742 5.57317 22.2742 11.724C22.2742 17.8749 17.288 22.8611 11.1371 22.8611C4.98625 22.8611 0 17.8749 0 11.724Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8036 9.63916L10.827 10.0245L10.4375 9.97734C9.01965 9.79645 7.78101 9.18301 6.72934 8.15274L6.21519 7.64153L6.08276 8.01904C5.80231 8.86056 5.98148 9.74927 6.56575 10.347C6.87735 10.6773 6.80724 10.7245 6.26972 10.5279C6.08276 10.465 5.91916 10.4178 5.90358 10.4414C5.84905 10.4964 6.03601 11.2121 6.18403 11.4952C6.38657 11.8885 6.79945 12.2738 7.25128 12.5019L7.633 12.6828L7.18117 12.6907C6.74492 12.6907 6.72934 12.6985 6.77608 12.8637C6.93188 13.3749 7.54731 13.9175 8.23284 14.1535L8.71584 14.3186L8.29517 14.5703C7.67195 14.9321 6.93967 15.1366 6.2074 15.1523C5.85684 15.1602 5.5686 15.1916 5.5686 15.2152C5.5686 15.2939 6.51901 15.7343 7.07211 15.9073C8.73142 16.4185 10.7023 16.1983 12.1825 15.3253C13.2341 14.704 14.2858 13.4693 14.7766 12.2738C15.0415 11.6368 15.3063 10.4728 15.3063 9.91442C15.3063 9.55265 15.3297 9.50546 15.7659 9.0729C16.023 8.82123 16.2645 8.54597 16.3113 8.46732C16.3892 8.31789 16.3814 8.31789 15.9841 8.45159C15.3219 8.68753 15.2284 8.65608 15.5556 8.30216C15.7971 8.0505 16.0853 7.59434 16.0853 7.46064C16.0853 7.43705 15.9685 7.47637 15.8361 7.54716C15.6958 7.6258 15.3842 7.74377 15.1505 7.81455L14.7299 7.94825L14.3481 7.68872C14.1378 7.54716 13.8418 7.38986 13.686 7.34267C13.2887 7.23257 12.681 7.2483 12.3227 7.37413C11.3489 7.72804 10.7335 8.64035 10.8036 9.63916Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.4697a56d185d7594e01caf2f210e640e.svg";
export { ForwardRef as ReactComponent };